import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Layout } from '@/components/layout/Layout'
import {
  Home,
  Music,
  Labs,
  Consulting,
  VoxNote,
  VoxNotePrivacy,
  VoxNoteSupport,
} from '@/pages'

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/music" element={<Music />} />
          <Route path="/labs" element={<Labs />} />
          <Route path="/consulting" element={<Consulting />} />
          <Route path="/labs/apps/voxnote" element={<VoxNote />} />
          <Route path="/labs/apps/voxnote/privacy" element={<VoxNotePrivacy />} />
          <Route path="/labs/apps/voxnote/support" element={<VoxNoteSupport />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  )
}

export default App
